"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.async = void 0;
const lit_html_1 = require("./lit-html/lit-html");
const directive_1 = require("./lit-html/directive");
const async_directive_1 = require("./lit-html/async-directive");
class ObserveDirective extends async_directive_1.AsyncDirective {
    // When the observable changes, unsubscribe to the old one and
    // subscribe to the new one
    render(asyncResult) {
        if ('then' in asyncResult) {
            Promise.resolve(asyncResult).then((v) => this.setValue(v));
            return '';
        }
        if (this.observable !== asyncResult) {
            this.unsubscribe();
            this.observable = asyncResult;
            if (this.isConnected) {
                this.subscribe(asyncResult);
            }
        }
        return lit_html_1.noChange;
    }
    // Subscribes to the observable, calling the directive's asynchronous
    // setValue API each time the value changes
    subscribe(observable) {
        this.subscription = observable.subscribe((v) => {
            this.setValue(v);
        });
    }
    // When the directive is disconnected from the DOM, unsubscribe to ensure
    // the directive instance can be garbage collected
    disconnected() {
        this.unsubscribe();
    }
    unsubscribe() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    // If the subtree the directive is in was disconneted and subsequently
    // re-connected, re-subscribe to make the directive operable again
    reconnected() {
        this.subscribe(this.observable);
    }
}
exports.async = (0, directive_1.directive)(ObserveDirective);
